(function () {
  const instances = new WeakMap();

  class AboutProlockeyRoute {
    constructor(root) {
      this.root = root;
      this.canvas = root.querySelector('[data-about-route]');
      this.context = this.canvas ? this.canvas.getContext('2d') : null;
      this.visual = root.querySelector('.about-prolockey__visual');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.timer = 0;
      this.running = false;
      this.visible = false;
      this.startedAt = performance.now();

      if (!this.canvas || !this.context || !this.visual) return;

      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.visual);

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.animate();
          else this.stop();
        },
        { rootMargin: '120px 0px', threshold: 0.05 }
      );
      this.intersectionObserver.observe(root);
      this.resize();
    }

    resize() {
      const bounds = this.visual.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      this.width = Math.max(1, bounds.width);
      this.height = Math.max(1, bounds.height);
      this.canvas.width = Math.round(this.width * ratio);
      this.canvas.height = Math.round(this.height * ratio);
      this.canvas.style.width = `${this.width}px`;
      this.canvas.style.height = `${this.height}px`;
      this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
      this.draw(this.reducedMotion.matches ? 0.48 : 0);
    }

    buildPath() {
      const w = this.width;
      const h = this.height;
      const path = new Path2D();
      path.moveTo(w * 0.06, h * 0.08);
      path.bezierCurveTo(w * 0.27, h * 0.09, w * 0.42, h * 0.12, w * 0.43, h * 0.24);
      path.bezierCurveTo(w * 0.45, h * 0.35, w * 0.54, h * 0.36, w * 0.49, h * 0.49);
      path.bezierCurveTo(w * 0.43, h * 0.61, w * 0.39, h * 0.67, w * 0.52, h * 0.75);
      path.bezierCurveTo(w * 0.63, h * 0.82, w * 0.82, h * 0.78, w * 0.94, h * 0.67);
      path.bezierCurveTo(w * 1.04, h * 0.57, w * 0.98, h * 0.29, w * 0.83, h * 0.2);
      path.bezierCurveTo(w * 0.69, h * 0.1, w * 0.55, h * 0.2, w * 0.58, h * 0.43);
      path.bezierCurveTo(w * 0.6, h * 0.65, w * 0.76, h * 0.76, w * 0.86, h * 0.92);
      return path;
    }

    draw(progress) {
      const ctx = this.context;
      const w = this.width;
      const h = this.height;
      const path = this.buildPath();
      this.canvas.dataset.routeProgress = progress.toFixed(4);
      ctx.clearRect(0, 0, w, h);

      ctx.save();
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'rgba(181, 35, 40, .28)';
      ctx.lineWidth = 1.25;
      ctx.stroke(path);
      ctx.restore();

      ctx.save();
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(245, 100, 92, .98)';
      ctx.lineWidth = 2.2;
      ctx.shadowColor = 'rgba(239, 82, 76, .9)';
      ctx.shadowBlur = 14;
      ctx.setLineDash([34, 1140]);
      ctx.lineDashOffset = -(progress * 1174);
      ctx.stroke(path);
      ctx.restore();
    }

    animate = () => {
      if (!this.visible || this.running) return;
      this.running = true;

      const tick = () => {
        if (!this.visible || !this.running) return;

        const durationValue = getComputedStyle(this.root).getPropertyValue('--about-route-duration');
        const duration = Math.max(7000, (parseFloat(durationValue) || 12) * 1000);
        const progress = this.reducedMotion.matches ? 0.48 : ((performance.now() - this.startedAt) % duration) / duration;
        this.draw(progress);
      };

      tick();
      if (!this.reducedMotion.matches) this.timer = window.setInterval(tick, 32);
      else this.running = false;
    };

    stop() {
      this.running = false;
      if (this.timer) clearInterval(this.timer);
      this.timer = 0;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    destroy() {
      this.stop();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-about-prolockey]').forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new AboutProlockeyRoute(root));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-about-prolockey]');
    if (!root) return;
    instances.get(root)?.destroy();
    instances.delete(root);
  });
})();
